import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { AccountType } from "__generated__/enums";
import { DataFormat } from "utils";

const AccountTypeSelect = <Multiple extends boolean = false,>({
	...rest
}: Omit<SelectProps<AccountType, Multiple>, "fetchOptions" | "paginated">) => {
	return (
		<Select
			getOptionLabel={option => DataFormat.userType(option)}
			{...rest}
			fetchOptions={Object.values(AccountType)}
		/>
	);
};

export default AccountTypeSelect;
